import { FC } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';

interface DataTableEmptyProps {
    message?: string;
    description?: string;
    icon?: React.ReactNode;
}

export const DataTableEmpty: FC<DataTableEmptyProps> = ({
    message = 'No Data Found',
    description,
    icon,
}) => {
    return (
        <Paper
            elevation={0}
            sx={{
                p: 6,
                textAlign: 'center',
                backgroundColor: 'background.default',
                border: '1px dashed',
                borderColor: 'divider',
                borderRadius: 2,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                }}
            >
                <Box
                    sx={{
                        color: 'text.secondary',
                        opacity: 0.5,
                    }}
                >
                    {icon || <InboxIcon sx={{ fontSize: 64 }} />}
                </Box>
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 600,
                        color: 'text.primary',
                    }}
                >
                    {message}
                </Typography>
                {description && (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ maxWidth: 400 }}
                    >
                        {description}
                    </Typography>
                )}
            </Box>
        </Paper>
    );
};

